import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import GenericButton from 'components/Button';

function Button(props) {
  const { children, disabled, type = 'button', ...rest } = props;
  const { formState } = useFormContext();
  const { isSubmitting } = formState;

  return (
    <GenericButton
      {...rest}
      type={type}
      disabled={disabled || isSubmitting}
      waiting={isSubmitting && type === GenericButton.TYPES.SUBMIT}>
      {children}
    </GenericButton>
  );
}

Button.TYPES = GenericButton.TYPES;

Button.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

export default Button;
